const myAbility = [
    {id:1 ,name:'HTML' , percent : 90 ,percentstr : "90%" , category: 'web'  },
    {id:2 ,name:'CSS' , percent : 90 ,percentstr : "90%" , category: 'web'  },
    {id:3 ,name:'JS' , percent : 85 ,percentstr : "85%" , category: 'web'  },
    {id:4 ,name:'React' , percent : 80 ,percentstr : "80%" , category: 'web'  },
    {id:5 ,name:'BootStrap' , percent : 90 ,percentstr : "90%" , category: 'web'  },
    {id:6 ,name:'Tailwind ' , percent : 70 ,percentstr : "70%" , category: 'web'  },
    {id:7 ,name:'JS Libs ' , percent : 50 ,percentstr : "50%" , category: 'web'  },
    {id:8 ,name:'Redux ' , percent : 30 ,percentstr : "30%" , category: 'web'  },
    // {id:16 ,name:'Node JS ' , percent : 25 ,percentstr : "25%" , category: 'web'  },
    // {id:17 ,name:'WordPress' , percent : 50 ,percentstr : "50%" , category: 'web'  },
    {id:9 ,name:'Python' , percent : 50 ,percentstr : "50%" , category: 'language'  },
    {id:10 ,name:'++C' , percent : 40 ,percentstr : "40%" , category: 'language'  },
    {id:11 ,name:'JS' , percent : 85 ,percentstr : "85%" , category: 'language'  },
    // {id:12 ,name:'C' , percent : 30 ,percentstr : "40%" , category: 'language'  },
    {id:13 ,name:'ICDL' , percent : 60 ,percentstr : "60%" , category: 'other'  },
    {id:14 ,name:'Photoshop' , percent : 50 ,percentstr : "60%" , category: 'other'  },
    {id:15 ,name:'Picsart' , percent : 40 ,percentstr : "40%" , category: 'other'  },
    {id:16 ,name:'AI' , percent : 40 ,percentstr : "40%" , category: 'other'  },
]

export default myAbility